export const isCoder = (roles: string[]) => {
  return roles && roles.length === 1 && roles.indexOf('coder') !== -1;
};
